import classNames from 'classnames';
import type { FC, ReactNode } from 'react';
import { getTracingEvents } from 'utils/amplitude';
import type { TracingConfig } from 'utils/amplitude/amplitude.types';
import type { TextEditorProps, TextEditorType } from '../TextEditor';
import TextEditor from '../TextEditor';

type CommonTextEditorProps = Omit<TextEditorProps, 'renderFooter'> & {
  renderAttachments?: (editor: TextEditorType) => ReactNode;
  renderExtraEditorControls?: (editor: TextEditorType) => ReactNode;
  tracing?: TracingConfig;
  onToggleBold?: () => void;
  onToggleItalic?: () => void;
  onToggleUnderline?: () => void;
  onFocus?: () => void;
  variablesData?: Record<string, any>;
};

const getButtonsClasses = (isActive: boolean) =>
  classNames(
    'rounded',
    isActive ? 'ring-1 ring-taxes-700 bg-taxes-50' : 'bg-transparent',
  );

const CommonTextEditor: FC<CommonTextEditorProps> = ({
  renderAttachments,
  renderExtraEditorControls,
  tracing,
  onToggleBold,
  onToggleItalic,
  onToggleUnderline,
  onFocus,
  ...rest
}) => {
  const events = getTracingEvents(tracing, {
    onToggleBold,
    onToggleItalic,
    onToggleUnderline,
    onFocus,
  });
  return (
    <TextEditor
      className="text-primary-700 p-4 flex-1 min-h-[200px]"
      {...rest}
      onFocus={events.onFocus}
      renderFooter={(editor) => (
        <>
          {renderAttachments?.(editor)}
          <div className="flex items-center gap-6 p-4 bg-primary-25 rounded-b-lg">
            {/* <Button
              asDefault
              className={getButtonsClasses(isMarkActive(editor, MARK_BOLD))}
              onClick={() => {
                toggleMark(editor, MARK_BOLD);
                events.onToggleBold?.();
              }}
            >
              <BoldSignIcon className="text-primary-700 w-5 h-5" />
            </Button>
            <Button
              asDefault
              className={getButtonsClasses(isMarkActive(editor, MARK_ITALIC))}
              onClick={() => {
                toggleMark(editor, MARK_ITALIC);
                events.onToggleItalic?.();
              }}
            >
              <ItalicSignIcon className="text-primary-700 w-5 h-5" />
            </Button>
            <Button
              asDefault
              className={getButtonsClasses(
                isMarkActive(editor, MARK_UNDERLINE),
              )}
              onClick={() => {
                toggleMark(editor, MARK_UNDERLINE);
                events.onToggleUnderline?.();
              }}
            >
              <UnderlineSignIcon className="text-primary-700 w-5 h-5" />
            </Button> */}
            {renderExtraEditorControls?.(editor)}
          </div>
        </>
      )}
    />
  );
};

export default CommonTextEditor;
